/* eslint eqeqeq: 'off' */
import React, { Component } from 'react';
import {connect} from 'react-redux';
import Header from 'components/FacilityRequestComponents/Shared/Header';
import TitleBar from 'components/FacilityRequestComponents/Shared/TitleBar';
import NavigationBar from 'components/FacilityRequestComponents/Shared/NavigationBar';
import Footer from 'components/FacilityRequestComponents/Shared/Footer';
import {GetTenantWorkOrderLicenseInfo} from 'action/Administration/administrationAction';
import {GetTenantOriginById,GetEmployeeTenantDetail} from 'action/facilitiesAction';
import FacilityMaintenanceSubRouting from 'components/FacilityRequestComponents/SubRouting/FacilityMaintenanceSubRouting';
import {setAmplitudeEvent} from 'amplitude/amplitude';


let data=[];
class FacilityMaintenanceLayout extends Component {
    
    componentWillMount(){
        this.props.GetTenantWorkOrderLicenseInfo();
        var TUserId = localStorage.getItem('TenantUserID');
        if(TUserId !== null){
            const l_Request = this.props.GetEmployeeTenantDetail(TUserId);
            l_Request.then((response) => {
                if(this.props.employeeTenantDetails !== undefined && this.props.employeeTenantDetails !== null){
                    var lTenantID = this.props.employeeTenantDetails.tenantId;
                    this.props.GetTenantOriginById(lTenantID);
                }
            })
        }

    }

    componentWillReceiveProps(nextProps){
        if (this.props != nextProps) {
            this.setState({IsTenantFromWO:nextProps.getTenantOrigin});
        }
    }

    constructor(props){
        super(props);
        this.state={
            activePage:'Home',
            IsTenantFromWO: true
        }
        this.getActivePage = this.getActivePage.bind(this);
        this.amplitude_page_navigation = this.amplitude_page_navigation.bind(this);
    }

    getActivePage(data){  this.setState({  activePage:data}); } //returning active page text for title bar.

    amplitude_page_navigation(){
        var activePage = null;
        let pageType = window.location.hash.split("FacilityManagement/")[1];
        (pageType.includes("/"))? activePage= pageType.split("/")[0] : activePage = pageType;
        
        if (localStorage.getItem("previousPage") === null) {
            localStorage.setItem("previousPage","Login");
            localStorage.setItem("currentPage",activePage);
            let data = {'Primary Offering': 'TS'}
            data['Previous Page'] ='Login';
            data['Current Page'] =activePage;
            setAmplitudeEvent('Navigate to home screen', data);
        }
        else if(localStorage.getItem("previousPage") !== null &&  localStorage.getItem("currentPage") !== activePage){
           let current = localStorage.getItem("currentPage");
            localStorage.setItem("previousPage",current);
            localStorage.setItem("currentPage",activePage);
            let eventProperties = {'Primary Offering': 'TS'}
            eventProperties['Previous Page'] =current;
            eventProperties['Current Page'] =activePage;
            setAmplitudeEvent('Navigate to '+ activePage +' screen', eventProperties);
        }
    }

    render() {
        this.amplitude_page_navigation();
        let { userProfileDetails, getLicenseinfo, employeeTenantDetails} = this.props;    
        let allowTempAdjust = false;
        let zoneDetails;
        let managecomfort = true, maintenancerequest = true , afterhours = true, managehome = true;

        if (getLicenseinfo.licensedFeatures !== undefined && getLicenseinfo.licensedFeatures !== null && getLicenseinfo.licensedFeatures.length > 0){
            if (employeeTenantDetails !== undefined && employeeTenantDetails !== null && userProfileDetails !== undefined && userProfileDetails.user_info !== undefined){
                    var ZonesTemperatureCol = employeeTenantDetails.zonesTemperatureAdjustment;
                    if(ZonesTemperatureCol !== undefined && ZonesTemperatureCol !== null && ZonesTemperatureCol.length){
                        var IsTemperatureAdjustmentEnabled = ZonesTemperatureCol.filter(x => x.allowTemperatureAdjustment === true);
                        allowTempAdjust = (IsTemperatureAdjustmentEnabled !== undefined && IsTemperatureAdjustmentEnabled !== null && IsTemperatureAdjustmentEnabled.length) ? true : false;
                    }

                    zoneDetails = employeeTenantDetails.zoneIds.length;
                    if (getLicenseinfo.licensedFeatures[0].licensed && getLicenseinfo.licensedFeatures[1].licensed && allowTempAdjust == false){
                            if (this.state.IsTenantFromWO){
                                managecomfort = false; afterhours = false;  
                                managehome = false;
                            }
                            else{
                                managecomfort = false;
                            }
                            
                    }
                    else if (getLicenseinfo.licensedFeatures[0].licensed && getLicenseinfo.licensedFeatures[1].licensed == false){
                        if(allowTempAdjust){
                            maintenancerequest = false;                           
                        }   
                        else{
                            managecomfort = false;   
                            maintenancerequest = false;
                            managehome = false;
                        }
                    }
                    else if (getLicenseinfo.licensedFeatures[0].licensed == false && getLicenseinfo.licensedFeatures[1].licensed){
                           managecomfort = false; afterhours = false; managehome = false;
                    }
            }
        }   
              
        data = [managehome, managecomfort, afterhours, maintenancerequest];

        return (
            <div style={{backgroundColor: '#EEEEEE',height: '100vh',overflowY:'auto',overflowX: 'hidden',width:'100%'}}>
                <Header />
                <TitleBar {...this.state}/>
                {(managecomfort == true && zoneDetails == 0 && maintenancerequest == false) ? "" :  <NavigationBar onGetActivePage={this.getActivePage} OnGetActiveTab={data}/>}
                    <FacilityMaintenanceSubRouting style={{width:'100%',float:'left'}} onGetActivePage={this.getActivePage} zoneDetails={zoneDetails}/>
                <Footer/>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        userProfileDetails: state.userDetailsRootReducer,
        getLicenseinfo: state.InstallationsRootReducer.TenantWorkOrderLicense,
        getTenantOrigin: state.facilityRootReducer.EmployeeTenantOrigin,
        employeeTenantDetails: state.FacilityRequestsEmployeeTenantDetails.EmployeeTenantDetails
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetTenantWorkOrderLicenseInfo: () => dispatch(GetTenantWorkOrderLicenseInfo()),
        GetTenantOriginById: (id) => dispatch(GetTenantOriginById(id)),
        GetEmployeeTenantDetail: (employeeID) => dispatch(GetEmployeeTenantDetail(employeeID)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FacilityMaintenanceLayout);
